import { Props } from "./Button";

export { default } from "./Button";
export type ButtonProps = Props;
